var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTorch = function SvgTorch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.47 21.61 43 17.05a1.28 1.28 0 0 1 1.77 1.76l-4.57 4.57a1.28 1.28 0 0 1-1.77-1.77zM33 17.77l2.57-6.12a1 1 0 0 1 1.45-.31 1.36 1.36 0 0 1 .67 1.57L35.14 19a1 1 0 0 1-1.45.32 1.34 1.34 0 0 1-.69-1.55zm11.08 11.06 6.12-2.58a1 1 0 0 0 .32-1.45 1.34 1.34 0 0 0-1.52-.66l-6.12 2.57a1 1 0 0 0-.32 1.45 1.34 1.34 0 0 0 1.52.67zm-7.94-.55L34.86 27l-5.56-5.56-3.25 3.25-2.52 6.9L13.3 41.83a3 3 0 0 0 0 4.17l2.55 2.56a3 3 0 0 0 4.18 0l10-10 7.12-2.74 3.25-3.26zm-9.75 10.38-2.74 2.74a2.26 2.26 0 0 1-3.2-3.2l2.74-2.74a2.26 2.26 0 0 1 3.2 3.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.89 38.27a1.63 1.63 0 0 1-2.3-2.27 1.63 1.63 0 1 1 2.3 2.31z"
  })));
};

export default SvgTorch;